import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export default function AdminResetCard({ t }) {
  const [busy, setBusy] = useState(false);

  const reset = async () => {
    if (!window.confirm(t("adminReset.confirm"))) return;
    setBusy(true);
    try {
      const { data } = await api.post("/admin/reset-test-data");
      toast.success(`${t("adminReset.done")}: ${data.removed_pixels}`);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="px-5 md:px-12 pb-16" data-testid="admin-reset-card">
      <div className="border border-[#b04a3a]/50 p-8">
        <div className="text-[10px] tracking-[0.3em] text-[#b04a3a]">ADMIN</div>
        <h3 className="mt-2 font-display text-2xl font-bold tracking-tight">{t("adminReset.title")}</h3>
        <p className="mt-2 text-xs text-muted-foreground leading-relaxed max-w-2xl">{t("adminReset.note")}</p>
        <button
          onClick={reset}
          disabled={busy}
          data-testid="admin-reset-btn"
          className="mt-6 px-6 py-3 border border-[#b04a3a] text-[#b04a3a] text-[10px] tracking-[0.25em] font-semibold hover:bg-[#b04a3a] hover:text-[#FAF8F5] disabled:opacity-40 transition-colors duration-200"
        >
          {busy ? t("common.loading").toUpperCase() : t("adminReset.btn").toUpperCase()}
        </button>
      </div>
    </div>
  );
}
